
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, filter, catchError, mergeMap, } from 'rxjs/operators';
import '../../shared/extensions/extension-method.component';



@Injectable()
export class AutherizationService {

  constructor(private http: HttpClient) { }

  checkPermssion(permissionName:string ) {

   
    let timeStamp = +new Date();
    let APIURL: string = "api/permission/checkpermission/" + permissionName;
    let NoCachedUrl = APIURL + '?tsp=' + timeStamp;
    APIURL = NoCachedUrl.toServerURL().toString();
    return this.http.get(APIURL);
   
  }

  logOut() {
    let APIURL: string = "api/login/LogOut/";
    APIURL = APIURL.toServerURL().toString();
    return this.http.get(APIURL).pipe
      (map((response: Response) => {
      }));
  }
   

}
